import { module } from 'modujs';
import { Picker } from 'emoji-picker-element';
import { $html } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);

        const acf_fields = document.querySelectorAll('.acf-field');
        const emoji_input = document.getElementById('acf-field_65d74e48da01a')
        const success = document.getElementById('message');
        const picker = new Picker();
        const style = document.createElement('style');
        style.textContent = `#skintone-button {visibility: hidden} .search-wrapper {display: none}`
        picker.shadowRoot.appendChild(style);
        document.querySelector('main').appendChild(picker);

        if (picker) {
            const emoji_close = window.getComputedStyle(picker, ':after');
            const pseudoWidth = parseInt(emoji_close.width ?? 0) + parseInt(emoji_close.paddingLeft ?? 0) + parseInt(emoji_close.paddingRight ?? 0);

            picker.addEventListener('click', (e) => {
                if (e.offsetX >= picker.offsetWidth - pseudoWidth) {
                    picker.classList.remove('is-visible')
                }
            })
        }

        if (acf_fields && picker) {
            acf_fields.forEach(field => {
                const label = field.querySelector('.acf-label label').innerText
                const input = field.querySelector('.acf-input input')
                input.placeholder = label;

                input.addEventListener('click', () => {
                    if (input != emoji_input) {
                        picker.classList.remove('is-visible')
                    }
                })
            })
        }

        if (emoji_input && picker) {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                emoji_input.readOnly = true;
            }
            emoji_input.addEventListener('click', () => {
                picker.classList.add('is-visible')

                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                    window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
                }
            })

            picker.addEventListener('emoji-click', (event) => {
                let old = emoji_input.value;

                if (emoji_input.value.length >= 6) return;
                emoji_input.value = old + event.detail.unicode
            });
        }

        if (success) {
            $html.classList.add('form-success')
        }


    }

    init() {
    }
}
